"use client";

import Link from "next/link";
import { NutcakeLongLogo } from "@drpcrd/shared/ui";

/**
 * Simple top navigation for the contact page with just the Nutcake logo.
 */
export const ContactPageNavbar = () => (
  <header
    aria-label="Site navigation"
    className="sticky top-0 z-50 flex w-full items-center bg-white px-2 py-2"
  >
    <Link
      href="/"
      aria-label="Nutcake home"
      className="flex shrink-0 items-center"
    >
      <NutcakeLongLogo className="w-auto shrink-0 sm:h-5.25" />
    </Link>
  </header>
);
